import React from 'react';

import { UserRoleProvider } from 'context/user-role';

import { PublicLayout } from 'components/Layouts';
import GlobalScrollStyles from 'components/shared/CustomScroll/GlobalScrollStyles';

import PublicRoutes from 'routes/PublicRoutes';

const PublicApp = () => {
  return (
    <UserRoleProvider runProcessInit={false}>
      <PublicLayout>
        <GlobalScrollStyles baseColor="#6D46DD" sizePx={8} />
        <PublicRoutes />
      </PublicLayout>
    </UserRoleProvider>
  );
};

export default PublicApp;
